/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Variant_Not_SellableInputs */

const vi_shop_variant_not_sellable = /** @type {(inputs: Shop_Variant_Not_SellableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKU đang ngừng bán`)
};

/**

* @param {Shop_Variant_Not_SellableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_variant_not_sellable = /** @type {((inputs?: Shop_Variant_Not_SellableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Variant_Not_SellableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_variant_not_sellable(inputs)
});